export default "assets/images/properties-texture-002bca60.png";